package org.multipaz.wallet.shared

/**
 * Platform client types for wallet sessions.
 */
enum class ClientType {
    /**
     * Apple iOS native application client.
     */
    IOS,

    /**
     * Android native application client.
     */
    ANDROID,

    /**
     * Web application client.
     */
    WEB
}
